import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const formQueries = [
  'waiverForms',
  'waiverForm',
];

/** Queries that change when a form is published or otherwise status-updated. */
const formPublishedQueries = [
  ...formQueries,
  'waiverFormSubmissions',
];

const waiverFormMutations: UpdatesConfig['Mutation'] = {
  waiverFormCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formQueries, cache);
  },
  waiverFormUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formQueries, cache);
  },
  waiverFormStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formPublishedQueries, cache);
  },
  waiverFormDiscard: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formQueries, cache);
  },
  waiverFormRuleUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(formQueries, cache);
  },
};

export default waiverFormMutations;
